(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chat-widget"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-chat-widget]');
    if (!root) return;
    var panel = root.querySelector('#ChatPanel');
    var openBtn = root.querySelector('[data-chat-open]');
    var closeBtn = root.querySelector('[data-chat-close]');

    function setOpen(open) {
      openBtn.setAttribute('aria-expanded', String(open));
      if (open) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    }

    openBtn.addEventListener('click', function () {
      setOpen(openBtn.getAttribute('aria-expanded') !== 'true');
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var forms = document.querySelectorAll('.product-card__form');
    forms.forEach(function (form) {
      var btn = form.querySelector('.product-card__atc-btn');
      if (!btn) return;
      var originalLabel = btn.textContent.trim();

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (btn.disabled) return;

        btn.disabled = true;
        btn.textContent = btn.dataset.loading || '...';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart_error');
            return res.json();
          })
          .then(function () {
            btn.textContent = btn.dataset.added || 'Added';
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(function () {
              btn.textContent = originalLabel;
              btn.disabled = false;
            }, 1800);
          })
          .catch(function () {
            btn.textContent = originalLabel;
            btn.disabled = false;
          });
      });
    });

    document.querySelectorAll('[data-featured-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if (!track) return;

      function itemWidth() {
        var item = track.querySelector('.featured-collection__item');
        return item ? item.getBoundingClientRect().width : track.clientWidth;
      }

      function updateArrows() {
        var max = track.scrollWidth - track.clientWidth - 4;
        if (prev) prev.hidden = track.scrollLeft <= 4;
        if (next) next.hidden = track.scrollLeft >= max;
        if (track.scrollWidth <= track.clientWidth + 4) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
        }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -itemWidth() * 2, behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: itemWidth() * 2, behavior: 'smooth' });
        });
      }
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var toggle = header.querySelector('[data-menu-toggle]');
    var drawer = header.querySelector('#MobileNav');
    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        if (open) drawer.setAttribute('hidden', '');
        else drawer.removeAttribute('hidden');
      });
    }

    document.addEventListener('cart:updated', function () {
      var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      fetch(root + 'cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    });

    header.querySelectorAll('[data-mega]').forEach(function (item) {
      var hideTimer;
      item.addEventListener('mouseenter', function () {
        clearTimeout(hideTimer);
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function () {
        hideTimer = setTimeout(function () {
          item.classList.remove('is-open');
        }, 220);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('[data-hero-slider]');
    if (!hero) return;
    var slides = hero.querySelectorAll('[data-slide]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var caption = hero.querySelector('[data-hero-caption]');
    if (!slides.length) return;
    var index = 0;
    var timer;
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 5000;
    var autoplay = hero.getAttribute('data-autoplay') === 'true';

    function goTo(next) {
      slides[index].classList.remove('is-active');
      if (dots[index]) {
        dots[index].classList.remove('is-active');
        dots[index].setAttribute('aria-selected', 'false');
      }
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (dots[index]) {
        dots[index].classList.add('is-active');
        dots[index].setAttribute('aria-selected', 'true');
      }
      if (caption) caption.textContent = slides[index].getAttribute('data-caption') || '';
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { goTo(index + 1); }, interval);
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    var prev = hero.querySelector('[data-hero-prev]');
    var next = hero.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); start(); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); start(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-hero-dot'), 10));
        start();
      });
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    var timer;

    function root() {
      return document.querySelector('[data-cart-page]');
    }

    function sectionId() {
      var page = root();
      return page ? page.getAttribute('data-section-id') : '';
    }

    function replaceCart(html) {
      var holder = document.createElement('div');
      holder.innerHTML = html;
      var next = holder.querySelector('[data-cart-page]');
      var current = root();
      if (next && current) current.replaceWith(next);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }

    function refreshFromSection() {
      var id = sectionId();
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id))
        .then(function (res) { return res.text(); })
        .then(replaceCart)
        .catch(function () { window.location.reload(); });
    }

    function changeQty(key, quantity) {
      var id = sectionId();
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: id,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          return res.json();
        })
        .then(function (data) {
          if (data.sections && data.sections[id]) replaceCart(data.sections[id]);
          else refreshFromSection();
        })
        .catch(function () { refreshFromSection(); });
    }

    document.addEventListener('click', function (event) {
      var page = event.target.closest('[data-cart-page]');
      if (!page) return;
      var item = event.target.closest('.cart-item');
      if (!item) return;
      var key = item.getAttribute('data-key');
      var input = item.querySelector('[data-cart-qty-input]');
      if (event.target.closest('[data-cart-remove]')) {
        event.preventDefault();
        changeQty(key, 0);
        return;
      }
      var qtyBtn = event.target.closest('[data-cart-qty]');
      if (!qtyBtn || !input) return;
      event.preventDefault();
      var next = Math.max(0, Number(input.value || 1) + Number(qtyBtn.getAttribute('data-cart-qty')));
      input.value = String(next);
      changeQty(key, next);
    });

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-cart-qty-input]')) return;
      var item = event.target.closest('.cart-item');
      if (!item) return;
      changeQty(item.getAttribute('data-key'), Math.max(0, Number(event.target.value || 0)));
    });

    document.addEventListener('input', function (event) {
      if (!event.target.matches('#CartNote')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: event.target.value })
        }).catch(function () {});
      }, 400);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;

    var gallery = root.querySelector('[data-gallery]');
    var track = root.querySelector('[data-gallery-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = root.querySelectorAll('[data-gallery-goto]');
    var countEl = root.querySelector('[data-gallery-count]');
    var index = 0;
    slides.forEach(function (slide, i) {
      if (slide.getAttribute('data-initial') === 'true') index = i;
    });

    function goTo(next) {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
      if (countEl) countEl.textContent = index + 1 + ' / ' + slides.length;
      var activeThumb = thumbs[index];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      }
    }

    goTo(index);
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(Number(thumb.getAttribute('data-gallery-goto')));
      });
    });

    var thumbsViewport = root.querySelector('[data-thumbs-viewport]');
    var thumbsPrev = root.querySelector('[data-thumbs-prev]');
    var thumbsNext = root.querySelector('[data-thumbs-next]');
    function scrollThumbs(dir) {
      if (!thumbsViewport) return;
      thumbsViewport.querySelector('.pdp-gallery__thumbs').scrollBy({
        left: dir * 160,
        behavior: 'smooth'
      });
    }
    if (thumbsPrev) thumbsPrev.addEventListener('click', function () { scrollThumbs(-1); });
    if (thumbsNext) thumbsNext.addEventListener('click', function () { scrollThumbs(1); });

    root.querySelectorAll('[data-reviews-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('reviews:open'));
      });
    });

    var viewport = root.querySelector('[data-gallery-viewport]');
    if (viewport && slides.length > 1) {
      var startX = 0;
      viewport.addEventListener('touchstart', function (event) {
        startX = event.changedTouches[0].screenX;
      }, { passive: true });
      viewport.addEventListener('touchend', function (event) {
        var dx = event.changedTouches[0].screenX - startX;
        if (dx > 40) goTo(index - 1);
        if (dx < -40) goTo(index + 1);
      }, { passive: true });
    }

    var form = root.querySelector('[data-pdp-form]');
    if (!form) return;
    var jsonEl = form.querySelector('[data-variant-json]');
    var moneyEl = form.querySelector('[data-money-format]');
    var variants = [];
    var moneyFormat = '';
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}
    try { moneyFormat = JSON.parse(moneyEl.textContent); } catch (e) {}

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var atc = form.querySelector('[data-atc]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var statusEl = form.querySelector('[data-atc-status]');
    var addLabel = atc ? atc.getAttribute('data-label-add') : 'Add to bag';
    var soldLabel = atc ? atc.getAttribute('data-label-sold') : 'Sold out';
    var addedLabel = atc ? atc.getAttribute('data-label-added') : 'Added';
    var addingLabel = atc ? atc.getAttribute('data-label-adding') : 'Adding…';

    function formatMoney(cents) {
      var value = (Number(cents) / 100).toFixed(2);
      if (!moneyFormat) return '$' + value;
      var token = String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
      return String(moneyFormat).split(token).join(value);
    }

    function selectedOptions() {
      var values = [null, null, null];
      form.querySelectorAll('[data-option-index]:checked').forEach(function (input) {
        values[Number(input.getAttribute('data-option-index'))] = input.value;
      });
      return values;
    }

    function findVariant() {
      var options = selectedOptions();
      return variants.find(function (variant) {
        return variant.option1 === (options[0] || variant.option1) &&
          variant.option2 === (options[1] || variant.option2) &&
          variant.option3 === (options[2] || variant.option3);
      }) || null;
    }

    function updateVariant() {
      var variant = findVariant();
      form.querySelectorAll('.pdp-option').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        var label = fieldset.querySelector('[data-option-label]');
        if (checked && label) label.textContent = checked.value;
      });
      if (!variant) {
        if (atc) {
          atc.disabled = true;
          atc.textContent = soldLabel;
        }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s> <span class="price__sale">' + formatMoney(variant.price) + '</span>';
        } else {
          priceEl.innerHTML = '<span>' + formatMoney(variant.price) + '</span>';
        }
      }
      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? addLabel : soldLabel;
      }
      if (variant.featured_media_id) {
        var mediaIndex = slides.findIndex(function (slide) {
          return slide.getAttribute('data-media-id') === String(variant.featured_media_id);
        });
        if (mediaIndex >= 0) goTo(mediaIndex);
      }
      if (variant.id && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.querySelectorAll('[data-option-index]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    form.querySelectorAll('[data-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        var next = Number(qtyInput.value || 1) + Number(button.getAttribute('data-qty'));
        qtyInput.value = String(Math.max(1, next));
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!atc || atc.disabled) return;
      var original = atc.textContent;
      atc.disabled = true;
      atc.textContent = addingLabel;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form)).toString()
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          return res.json();
        })
        .then(function () {
          atc.textContent = addedLabel;
          if (statusEl) {
            statusEl.hidden = false;
            statusEl.textContent = addedLabel;
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            atc.textContent = original;
            atc.disabled = false;
          }, 1600);
        })
        .catch(function () {
          atc.textContent = original;
          atc.disabled = false;
          form.submit();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-product-reviews]');
    if (!root) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-review-card]'));
    var list = root.querySelector('[data-review-list]');
    var empty = root.querySelector('[data-review-empty]');
    var pager = root.querySelector('[data-review-pages]');
    var search = root.querySelector('[data-review-search]');
    var rating = root.querySelector('[data-review-rating]');
    var media = root.querySelector('[data-review-media]');
    var sort = root.querySelector('[data-review-sort]');
    var dialog = root.querySelector('[data-review-dialog]');
    var openBtn = root.querySelector('[data-review-open]');
    var perPage = 8;
    var page = 1;
    var drawer = root.querySelector('[data-reviews-drawer]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-reviews-open]').forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });
    document.addEventListener('reviews:open', openDrawer);
    root.querySelectorAll('[data-reviews-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    function visibleCards() {
      var query = (search && search.value || '').toLowerCase();
      var ratingValue = rating ? rating.value : '';
      var mediaOnly = media && media.checked;
      var filtered = cards.filter(function (card) {
        var text = card.textContent.toLowerCase();
        var okQuery = !query || text.indexOf(query) !== -1;
        var okRating = !ratingValue || card.getAttribute('data-rating') === ratingValue;
        var okMedia = !mediaOnly || card.getAttribute('data-has-media') === 'true';
        return okQuery && okRating && okMedia;
      });
      var mode = sort ? sort.value : 'highest';
      filtered.sort(function (a, b) {
        var ra = Number(a.getAttribute('data-rating'));
        var rb = Number(b.getAttribute('data-rating'));
        if (mode === 'lowest') return ra - rb;
        if (mode === 'newest') return String(b.getAttribute('data-date')).localeCompare(String(a.getAttribute('data-date')));
        return rb - ra;
      });
      return filtered;
    }

    function render() {
      var filtered = visibleCards();
      var pages = Math.max(1, Math.ceil(filtered.length / perPage));
      if (page > pages) page = pages;
      cards.forEach(function (card) { card.hidden = true; });
      filtered.forEach(function (card, index) {
        var start = (page - 1) * perPage;
        card.hidden = index < start || index >= start + perPage;
        list.appendChild(card);
      });
      if (empty) empty.hidden = filtered.length > 0;
      if (!pager) return;
      pager.innerHTML = '';
      if (filtered.length <= perPage) return;
      for (var i = 1; i <= pages; i++) {
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = String(i);
        if (i === page) button.className = 'is-active';
        button.addEventListener('click', function (current) {
          return function () { page = current; render(); };
        }(i));
        pager.appendChild(button);
      }
    }

    [search, rating, media, sort].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', function () { page = 1; render(); });
      el.addEventListener('change', function () { page = 1; render(); });
    });

    root.querySelectorAll('[data-helpful]').forEach(function (button) {
      button.addEventListener('click', function () {
        var count = button.parentElement.querySelector('[data-helpful-count]');
        if (!count) return;
        count.textContent = String(Number(count.textContent || 0) + 1);
      });
    });

    if (openBtn && dialog) {
      openBtn.addEventListener('click', function () {
        if (dialog.showModal) dialog.showModal();
      });
    }

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-related]');
    if (!root) return;

    function bindForms(scope) {
      scope.querySelectorAll('.related-card__form').forEach(function (form) {
        if (form.getAttribute('data-bound') === 'true') return;
        form.setAttribute('data-bound', 'true');
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var btn = form.querySelector('.related-card__btn');
          if (!btn || btn.disabled) return;
          var original = btn.textContent;
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-loading') || 'Adding…';
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(new FormData(form)).toString()
          })
            .then(function (res) {
              if (!res.ok) throw new Error('cart');
              return res.json();
            })
            .then(function () {
              btn.textContent = btn.getAttribute('data-added') || 'Added';
              document.dispatchEvent(new CustomEvent('cart:updated'));
              setTimeout(function () {
                btn.textContent = original;
                btn.disabled = false;
              }, 1600);
            })
            .catch(function () {
              btn.textContent = original;
              btn.disabled = false;
            });
        });
      });
    }

    bindForms(root);

    var url = root.getAttribute('data-url');
    if (!url || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries, obs) {
      if (!entries[0].isIntersecting) return;
      obs.unobserve(root);
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var next = html.querySelector('[data-related]');
          if (!next) return;
          var grid = next.querySelector('.related-products__grid');
          if (grid && grid.children.length) {
            root.innerHTML = next.innerHTML;
            bindForms(root);
          }
        })
        .catch(function () {});
    }, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(root);
  })();

  } catch(e) { console.error(e); }
})();
})();
